<div class="w-100">
  <h1 class="head1">Edit Project</h1>
</div>
<div class="row">
  <div class="col-md-6 mb-3">
    <div class="card shadow-sm p-3">
      <form #frm="ngForm" (submit)="frm.form.valid && onSubmit(frm)">
        <h5 class="font-15p mb-3">Project Details</h5>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Project Name<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              name="name"
              [(ngModel)]="project.name"
              #projname="ngModel"
              required
              pattern=".*\S.*"
              trimTextInput
            />
            @if(frm.submitted && projname.invalid) {
            @if(projname.hasError('required')) {
            <span class="m-0 text-danger">Project name is required.</span>
            }@if(projname.hasError('pattern')) {
            <span class="m-0 text-danger">Project name is required.</span>
            } }
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3">Company Name</label>
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              name="company_name"
              [(ngModel)]="project.company_name"
              trimTextInput
            />
          </div>
        </div>
        <h5 class="font-15p my-4">Admin Details</h5>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >User Name<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              name="username"
              [(ngModel)]="project.username"
              #userName="ngModel"
              required
              pattern=".*\S.*"
              trimTextInput
            />
            @if(frm.submitted && userName.invalid) {
            @if(userName.hasError('required')) {
            <span class="m-0 text-danger">User name is required.</span>
            }@if(userName.hasError('pattern')) {
            <span class="m-0 text-danger">User name is required.</span>
            } }
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Email<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <input
              type="email"
              class="form-control"
              name="email"
              [(ngModel)]="project.email"
              #email="ngModel"
              required
              pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
              trimTextInput
            />
            @if(frm.submitted && email.invalid) {
            @if(email.hasError('required')) {
            <span class="m-0 text-danger">Email is required.</span>
            } @if(email.hasError('pattern')) {
            <span class="m-0 text-danger">Invalid email address</span>
            }}
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3">Profile Image</label>
          <div class="col-md-9">
            <div class="d-flex">
              <input
                type="text"
                class="form-control me-2"
                name="selected_file_name"
                [(ngModel)]="selectedFileName"
                (click)="triggerFileInput()"
                readonly
              />
              <div class="custom-input-file">
                <label
                  for="fileInput"
                  class="file-input-label btn btn-primary-sa"
                  >Browse</label
                >
                <input
                  #fileInput
                  type="file"
                  class="file-input"
                  id="fileInput"
                  accept="image/*"
                  name="profile_image"
                  (change)="onFileSelected($event)"
                />
              </div>
            </div>
            @if(frm.submitted && fileError) {
            <span class="m-0 text-danger">{{ fileError }}</span>
            }
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3">Password</label>
          <div class="col-md-9">
            <input
              type="password"
              class="form-control"
              name="password"
              ngModel
              #password="ngModel"
              pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&'#'])[A-Za-z\d@$!%*?&'#']{8,}$"
            />
            @if(frm.submitted && password.invalid) {
            @if(password.hasError('pattern')) {
            <span class="m-0 text-danger"
              >Password must have at least 8 characters, include at least one
              uppercase letter, one lowercase letter, one number, and one
              special character</span
            >
            } }
          </div>
        </div>

        <h5 class="font-15p my-4">Personal Details</h5>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >First Name<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              name="firstname"
              [(ngModel)]="project.firstname"
              #firstName="ngModel"
              required
              pattern=".*\S.*"
              trimTextInput
            />
            @if(frm.submitted && firstName.invalid) {
            @if(firstName.hasError('required')) {
            <span class="m-0 text-danger">First name is required.</span>
            }@if(firstName.hasError('pattern')) {
            <span class="m-0 text-danger">First name is required.</span>
            } }
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Last Name<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              name="lastname"
              [(ngModel)]="project.lastname"
              #lastName="ngModel"
              required
              pattern=".*\S.*"
              trimTextInput
            />
            @if(frm.submitted && lastName.invalid) {
            @if(lastName.hasError('required')) {
            <span class="m-0 text-danger">Last name is required.</span>
            }@if(lastName.hasError('pattern')) {
            <span class="m-0 text-danger">Last name is required.</span>
            } }
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3">Date of Birth</label>
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              name="dob"
              [(ngModel)]="project.dob"
              bsDatepicker
              [bsConfig]="datePickerConfig"
              (keydown)="preventInput($event)"
            />
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3">Gender</label>
          <div class="col-md-9">
            <select
              class="form-select"
              name="gender"
              [(ngModel)]="project.gender"
            >
              <option value="">Select Gender</option>
              <option value="Female">Female</option>
              <option value="Male">Male</option>
              <option value="Others">Others</option>
            </select>
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Phone Number<span class="text-danger">*</span></label
          >
          <div class="col-md-3">
            <select
              class="form-control"
              name="country_code"
              [(ngModel)]="defaultCountryCode"
            >
              <option
                *ngFor="let country of countryCodes"
                [value]="country.dial_code"
              >
                {{ country.name }} ({{ country.dial_code }})
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <input
              type="text"
              class="form-control"
              name="phone_no"
              [(ngModel)]="project.phone_no"
              #phone="ngModel"
              required
              pattern="^[0-9]{10}$"
              trimTextInput
            />
            @if(frm.submitted && phone.invalid) {
            @if(phone.hasError('required')) {
            <span class="m-0 text-danger">Phone number is required.</span>
            } @if(phone.hasError('pattern')) {
            <span class="m-0 text-danger">Phone number must be 10 digits.</span>
            }}
          </div>
        </div>
        <div class="mb-4 row">
          <label class="col-form-label col-md-3">Contact Info</label>
          <div class="col-md-9">
            <textarea
              name=""
              id=""
              class="form-control"
              name="contact_info"
              [(ngModel)]="project.contact_info"
            ></textarea>
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3">&nbsp;</label>
          <div class="col-md-9 text-end">
            <button
              type="button"
              class="btn bbtn-secondary-sa ms-2 mb-2"
              (click)="oncancel()"
            >
              Cancel
            </button>
            <button class="btn btn-primary-sa ms-2 mb-2">Submit</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
